<template>
  <div>
    <el-pagination
      :current-page="pageData.page"
      :page-size="pageData.size"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    pageData: {
      type: Object,
      default() {
        return { size: 10, page: 1, total: 0 };
      },
    },
    sizeChange: {
      type: Function,
      default: function () {},
    },
    currentChange: {
      type: Function,
      default: function () {},
    },
  },

  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.el-pagination {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}
::v-deep .el-pager {
  width: inherit;
}
::v-deep .el-pager li {
  width: 35px;
}
::v-deep .el-input__inner,::v-deep .btn-prev,::v-deep .el-pager li,::v-deep .btn-next{
  background-color: #f2f6f7 !important;
}
</style>